import React, {useEffect, useState} from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  VStack,
  Box,
  useTheme,
} from '@chakra-ui/react';
import {useNavigate} from 'react-router-dom';
import {TextA18, TextG14} from '../typography';
import {BlueButton} from '../button';
import Icon from '../Icon';

const STORAGE_KEY = 'hasSeenFeedMovedNotice';

const FeedMovedModal: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Check if user has already seen this notice
    const hasSeenNotice = localStorage.getItem(STORAGE_KEY);

    if (!hasSeenNotice) {
      // Show modal after a short delay for better UX
      setTimeout(() => {
        setIsOpen(true);
      }, 500);
    }
  }, []);

  const handleClose = () => {
    // Mark as seen in localStorage
    localStorage.setItem(STORAGE_KEY, 'true');
    setIsOpen(false);
  };

  const handleNavigateToActivities = () => {
    handleClose();
    navigate('/search/activities');
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered size="sm">
      <ModalOverlay bg="rgba(0, 0, 0, 0.6)" />
      <ModalContent mx={4} borderRadius="16px">
        <ModalCloseButton />
        <ModalBody px={6} py={8}>
          <VStack spacing={5} align="center">
            <Box
              p={4}
              borderRadius="50%"
              bg={theme.colors.lightBlue}
              color="white"
              display="flex"
              alignItems="center"
              justifyContent="center">
              <Icon
                iconName="fi-rr-sparkles"
                style={{
                  fontSize: '32px',
                  width: '32px',
                  height: '32px',
                }}
              />
            </Box>

            <VStack spacing={3} align="center" textAlign="center">
              <TextA18 fontWeight="700" color={theme.colors.lightBlack}>
                Events and Meet-Ups Have Moved!
              </TextA18>
              <TextG14 color={theme.colors.grey}>
                You can now find all Events and Meet-Ups on the{' '}
                <Box as="span" fontWeight="600" color={theme.colors.lightBlack}>
                  Activities
                </Box>{' '}
                page.
              </TextG14>
            </VStack>

            <VStack spacing={2} width="full" pt={2}>
              <BlueButton
                onClick={handleNavigateToActivities}
                width="full"
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap={2}>
                Explore Activities
                <Icon
                  iconName="fi-rr-arrow-right"
                  style={{
                    fontSize: '16px',
                    width: '16px',
                    height: '16px',
                  }}
                />
              </BlueButton>
              <Box
                as="button"
                onClick={handleClose}
                py={2}
                color={theme.colors.grey}
                fontSize="14px"
                fontWeight="500"
                _hover={{color: theme.colors.lightBlack}}
                transition="color 0.2s">
                Maybe Later
              </Box>
            </VStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default FeedMovedModal;
